import gql from 'graphql-tag';

import thumbnailInfoFragment from '../fragments/thumbnailInfoFragment';

export const queryIntegrationItemThumbnailInfo = gql`
  query integrationItemThumbnailInfo(
    $accountID: DokkioID
    $integrationID: DokkioID!
    $remoteID: ID!
    $maxWidth: Int
    $maxHeight: Int
  ) {
    integrationItemThumbnailInfo(
      accountID: $accountID
      integrationID: $integrationID
      remoteID: $remoteID
      maxWidth: $maxWidth
      maxHeight: $maxHeight
    ) {
      ...thumbnailInfoFragment
    }
  }
  ${thumbnailInfoFragment}
`;

export default queryIntegrationItemThumbnailInfo;
